import { render } from "./Margin.vue?vue&type=template&id=821ee570"
import script from "./Margin.vue?vue&type=script&lang=js"
export * from "./Margin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__